const KEY = "appyhour_profile";

export function getProfile() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function saveProfile(profile) {
  localStorage.setItem(KEY, JSON.stringify(profile));
  return profile;
}

export function createProfile(handle, name) {
  const profile = {
    handle,
    name,
    createdAt: new Date().toISOString(),
    history: [],
    badges: [],
    groups: [],
    offers: [],
  };
  return saveProfile(profile);
}

export function awardOffer(profile, offer) {
  const p = { ...profile, offers: [...(profile.offers || [])] };
  const code = "AH-" + Math.random().toString(36).slice(2, 7).toUpperCase();
  const entry = { ...offer, code, date: new Date().toISOString() };
  p.offers.unshift(entry);
  saveProfile(p);
  return { profile: p, entry };
}

export function logout() {
  localStorage.removeItem(KEY);
}

const BADGE_DEFS = [
  { id: "first_quiz", name: "First Round", emoji: "🍻", desc: "Played your first quiz" },
  { id: "perfect", name: "Perfect Round", emoji: "💯", desc: "Scored 5 out of 5" },
  { id: "sharp", name: "Sharpshooter", emoji: "🎯", desc: "Scored 4 or more" },
  { id: "local_legend", name: "Local Legend", emoji: "🏆", desc: "Played a Local Trivia quiz" },
  { id: "social", name: "Social Butterfly", emoji: "🦋", desc: "Joined a group" },
  { id: "regular", name: "Pub Regular", emoji: "🌟", desc: "Played 3+ quizzes" },
];

export function getBadgeDef(id) {
  return BADGE_DEFS.find((b) => b.id === id);
}
export { BADGE_DEFS };

export function recordResult(profile, { category, categoryId, difficulty, score, total, venue }) {
  const p = { ...profile, history: [...profile.history], badges: [...profile.badges], groups: [...profile.groups] };
  p.history.unshift({
    category,
    categoryId,
    difficulty,
    score,
    total,
    venue: venue || "Solo Play",
    date: new Date().toISOString(),
  });

  const earned = new Set(p.badges);
  const newlyEarned = [];
  const award = (id) => {
    if (!earned.has(id)) {
      earned.add(id);
      newlyEarned.push(id);
    }
  };

  award("first_quiz");
  if (score === total) award("perfect");
  if (score >= 4) award("sharp");
  if (categoryId === "local" || categoryId === "lore") award("local_legend");
  if (p.history.length >= 3) award("regular");

  p.badges = Array.from(earned);
  saveProfile(p);
  return { profile: p, newlyEarned };
}

export function toggleRedeem(profile, code) {
  const p = {
    ...profile,
    offers: (profile.offers || []).map((o) =>
      o.code === code
        ? { ...o, redeemed: !o.redeemed, redeemedAt: !o.redeemed ? new Date().toISOString() : null }
        : o
    ),
  };
  saveProfile(p);
  return p;
}

export function joinGroup(profile, groupName) {
  if (profile.groups.includes(groupName)) return { profile, newlyEarned: [] };
  const p = { ...profile, groups: [...profile.groups, groupName], badges: [...profile.badges] };
  const newlyEarned = [];
  if (!p.badges.includes("social")) {
    p.badges.push("social");
    newlyEarned.push("social");
  }
  saveProfile(p);
  return { profile: p, newlyEarned };
}
